import { useState } from 'react';

type AnchorElement = HTMLElement | null;
type ClickShareHandler = (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
type CloseShareHandler = () => void;

export function useSharePopover(): [AnchorElement, ClickShareHandler, CloseShareHandler] {
  const [state, setState] = useState<AnchorElement>(null);

  const handleClickShare = (event?: React.MouseEvent<HTMLElement, MouseEvent>): void => {
    if (!event) {
      console.error('could not share plex because event is empty');
      return;
    }
    setState(event.currentTarget);
  };

  const handleCloseShare = (): void => {
    setState(null);
  };

  return [state, handleClickShare, handleCloseShare];
}
